import InputText from './InputText';

export { InputText };
